var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallLogRecordings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6932_35133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.51672 11.5042L2.5311 12.5195C3.05852 13.0467 3.77376 13.3429 4.51954 13.3429C5.26531 13.3429 5.98055 13.0467 6.50797 12.5195L7.99954 11.0279C8.13022 10.8973 8.23388 10.7422 8.30461 10.5716C8.37533 10.4009 8.41174 10.218 8.41174 10.0332C8.41174 9.84847 8.37533 9.66553 8.30461 9.49486C8.23388 9.32419 8.13022 9.16913 7.99954 9.03853L5.09985 6.13791C4.95785 5.99467 4.78671 5.88365 4.59802 5.81238C4.40934 5.74112 4.20753 5.71128 4.0063 5.72488C3.80506 5.73849 3.60911 5.79522 3.43173 5.89124C3.25436 5.98725 3.09971 6.12029 2.97829 6.28134C-0.0601505 10.4063 1.7811 14.7507 5.51516 18.4857C9.24922 22.2207 13.5964 24.0601 17.7242 21.0217C17.8849 20.8998 18.0175 20.7448 18.113 20.5672C18.2085 20.3896 18.2647 20.1936 18.2777 19.9924C18.2908 19.7911 18.2605 19.5895 18.1887 19.401C18.117 19.2125 18.0056 19.0417 17.862 18.9001L14.9614 15.9995C14.8308 15.8688 14.6758 15.7651 14.5051 15.6944C14.3344 15.6237 14.1515 15.5873 13.9667 15.5873C13.782 15.5873 13.599 15.6237 13.4284 15.6944C13.2577 15.7651 13.1026 15.8688 12.972 15.9995L11.4805 17.491C11.2193 17.7522 11.012 18.0623 10.8707 18.4035C10.7293 18.7448 10.6565 19.1106 10.6565 19.4799C10.6565 19.8493 10.7293 20.2151 10.8707 20.5563C11.012 20.8976 11.2193 21.2077 11.4805 21.4688L12.5117 22.4945",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2969 7.07812C11.2969 8.56997 11.8895 10.0007 12.9444 11.0556C13.9993 12.1105 15.43 12.7031 16.9219 12.7031C18.4137 12.7031 19.8445 12.1105 20.8994 11.0556C21.9542 10.0007 22.5469 8.56997 22.5469 7.07812C22.5469 5.58628 21.9542 4.15554 20.8994 3.10065C19.8445 2.04576 18.4137 1.45313 16.9219 1.45312C15.43 1.45313 13.9993 2.04576 12.9444 3.10065C11.8895 4.15554 11.2969 5.58628 11.2969 7.07812Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5156 7.07812C15.5156 7.45109 15.6638 7.80877 15.9275 8.07249C16.1912 8.33622 16.5489 8.48438 16.9219 8.48438C17.2948 8.48438 17.6525 8.33622 17.9162 8.07249C18.18 7.80877 18.3281 7.45109 18.3281 7.07812C18.3281 6.70516 18.18 6.34748 17.9162 6.08376C17.6525 5.82003 17.2948 5.67188 16.9219 5.67188C16.5489 5.67188 16.1912 5.82003 15.9275 6.08376C15.6638 6.34748 15.5156 6.70516 15.5156 7.07812Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6932_35133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallLogRecordings);
export default __webpack_public_path__ + "static/media/call-log-recordings.2798b447f5213771985b387459dbaaa0.svg";
export { ForwardRef as ReactComponent };